<template>
    <slot name="filter-field-selector" v-bind="this"></slot>
</template>

<script>
export default {
    props: {
        filterItem: null
    },
    data() {
        return {
            selectedOptions: [],
        };
    },
    watch: {
        selectedOptions: {
            handler(newValue) { },
            deep: true,
        },
    },
    methods: {
        changed(updatedOption) {

            this.filterItem.options.forEach(opt => {
                opt.checked = (opt.value === updatedOption.value);
            });

            const index = this.filterItem.options.findIndex(
                (opt) => opt.value === updatedOption.value
            );


            if (index !== -1) {
                this.filterItem.options[index] = updatedOption;
            }


            this.$emit("update-option", this.filterItem);
        }

    },
};
</script>
